import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthentication } from 'shared/hooks/useAuthentication';
import { Button } from './Button';

export const LogoutButton: FC = () => {
  const { t } = useTranslation();
  const { logout, logoutLoading } = useAuthentication();
  return (
    <Button
      loading={logoutLoading}
      variant="text"
      className="hover:text-primary px-2 py-2 text-xs text-black/70"
      onClick={logout}
    >
      {t('action:logout')}
    </Button>
  );
};
